import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Studio", to: "/studios" },
    { label: "Book", to: "/book" },
    { label: "Beats", to: "/beats" },
    { label: "Apps", to: "/apps" },
  ];

  return (
    <header className="backdrop-blur-2xl bg-black/70 border-b border-white/10 sticky top-0 z-50">
      <div className="px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img src="/logo.png" alt="Ceinaru Media" className="h-9 w-9 group-hover:rotate-180 transition-transform duration-700" />
          <span className="font-display font-extrabold text-xl tracking-tight">CEINARU<span className="text-[#D90429]"> MEDIA</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm uppercase tracking-[0.15em] text-[#A0A0A0] hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
          {user && (
            <Link to={user.role === "admin" ? "/admin" : "/dashboard"} data-testid="nav-dashboard"
              className="text-sm uppercase tracking-[0.15em] text-[#A0A0A0] hover:text-white transition-colors">
              {user.role === "admin" ? "Admin" : "My Bookings"}
            </Link>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          {user ? (
            <div className="flex items-center gap-3">
              {user.picture && <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-white/20" />}
              <button onClick={logout} data-testid="logout-button"
                className="flex items-center gap-2 text-sm text-[#A0A0A0] hover:text-[#D90429] transition-colors">
                <LogOut className="h-4 w-4" /> Logout
              </button>
            </div>
          ) : (
            <button onClick={() => navigate("/login")} data-testid="nav-login-button"
              className="bg-[#D90429] hover:bg-[#ED2939] text-white px-7 py-3 text-sm font-bold uppercase tracking-wide transition-colors">
              Sign In
            </button>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 px-6 py-6 flex flex-col gap-5 bg-black/95">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.15em] text-[#A0A0A0]">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.15em] text-[#A0A0A0]">
                {user.role === "admin" ? "Admin" : "My Bookings"}
              </Link>
              <button onClick={logout} className="text-left text-sm uppercase tracking-[0.15em] text-[#D90429]">Logout</button>
            </>
          ) : (
            <button onClick={() => navigate("/login")} className="bg-[#D90429] text-white px-7 py-3 text-sm font-bold uppercase">Sign In</button>
          )}
        </div>
      )}
    </header>
  );
}
